import { type Resolver, schemaBuckets } from 'cpool-schemas';
import type { z } from 'zod';

type Arguments = {
    position?: number;
};

export const schemaSystemVariableResolver_GetBucketConfigurations = schemaBuckets.nullable();

export type SchemaSystemVariableResolver_GetBucketConfigurations = z.infer<
    typeof schemaSystemVariableResolver_GetBucketConfigurations
>;

export type SystemVariableResolver_GetBucketConfigurations = Resolver<
    Arguments,
    SchemaSystemVariableResolver_GetBucketConfigurations
>;
